module.exports = __webpack_public_path__ + "sprite/win-sign@2x.png";


//////////////////
// WEBPACK FOOTER
// ./sprite/win-sign@2x.png
// module id = 132
// module chunks = 3